import React from 'react'
import { observer } from 'mobx-react'
import { FormGroup, ControlLabel, FormControl, HelpBlock, Tooltip, OverlayTrigger } from 'react-bootstrap'
import { PARAMS_DIVIDER } from '../../../constants/default_constants'

export default observer(({ attr, errors, label, record, onChange, items, store }) => {
  const errorText = errors ? errors.get(attr) : undefined
  const value = record.get(attr)

  function handleChange (evt) {
    if (evt.target.value.length === 0) {
      return onChange(attr, null)
    }
    const foundItem = items.find(i => i.id === parseInt(evt.target.value))
    onChange(attr, foundItem.id)
  }

  const renderedOpts = items.map((i, idx) => i.id && <option key={idx} value={i.id}>
    {i.id || store.__('new')}
    {i.start_license_period
      ? (typeof i.start_license_period === 'object'
        ? PARAMS_DIVIDER + i.start_license_period.format('YYYY-MM-DD')
        : PARAMS_DIVIDER + i.start_license_period.split('T')[0])
      : '-' }
    {' / '}
    {i.end_license_period
      ? (typeof i.end_license_period === 'object'
        ? i.end_license_period.format('YYYY-MM-DD')
        : i.end_license_period.split('T')[0])
      : '-' }
    {i.regions
      ? (i.regions.length > 15
        ? PARAMS_DIVIDER + i.regions.substring(0, 15)
        : PARAMS_DIVIDER + i.regions)
      : null}
    {i.platform
      ? (store.options.has('Platforms')
        ? PARAMS_DIVIDER + store.options.get('Platforms').find((j) => j.value === i.platform).text
        : PARAMS_DIVIDER + i.platform)
      : null}
    {i.right_type
      ? (store.options.has('RightsTypes')
        ? PARAMS_DIVIDER + store.options.get('RightsTypes').find((j) => j.value === i.right_type).text
        : PARAMS_DIVIDER + i.right_type)
      : null}
    {i.pricing_tier ? PARAMS_DIVIDER + i.pricing_tier : null}
  </option>)

  const unsavedOpts = items.filter(i => i.id === undefined).length > 0
  const unsavedOptsOverlaj = unsavedOpts ? (
    <Tooltip id={attr + 'tooltip'}>
      <strong>
        {store.__('You have to save the edited contract item in order to select previously created item share')}
      </strong>
    </Tooltip>
  ) : null
  const unsavedOptsTTip = unsavedOpts ? (
    <OverlayTrigger placement='right' overlay={unsavedOptsOverlaj}>
      <span className='glyphicon glyphicon-exclamation-sign' />
    </OverlayTrigger>
  ) : null

  return (
    <FormGroup controlId={attr} validationState={errorText ? 'error' : null}>
      {unsavedOptsTTip}
      <ControlLabel>{label}</ControlLabel>
      <FormControl componentClass='select' placeholder='select'
        value={value || ''} onChange={handleChange}>
        <option />
        {renderedOpts}
      </FormControl>
      {errorText ? <HelpBlock>{errorText}</HelpBlock> : null}
    </FormGroup>
  )
})
